import React from 'react';
import { TableRow } from './TableRow';
import { NoRows } from '../../../../layout/Table/NoRows';

function TableBody(props) {
  const renderRows = () => {
    const { appointmentHolidays } = props;

    if (!Array.isArray(appointmentHolidays) || appointmentHolidays.length === 0) {
      return <NoRows colSpan="8"/>;
    }

    return appointmentHolidays.map(renderRow);
  };

  const renderRow = (appointmentHoliday, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        key={ index }
        appointmentHoliday={ appointmentHoliday }
        actionCallback={ actionCallback }
        index= { index }
      />
    )
  }
    return (
      <tbody>
      { renderRows() }
      </tbody>
    )
}

export { TableBody };
